import QRCode from "qrcode";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import {
  PrintSize,
  PRINT_DIMENSIONS,
  LocationReviewRequestPrintsSizeOptions,
} from "../../../../models/LocationReviewRequestPrints";

import "./styles.scss";

interface ReviewRequestPrintPreviewProps {
  size: PrintSize;
  qrCodeUrl: string;
  options: LocationReviewRequestPrintsSizeOptions;
  className?: string;
  qrRef?: React.RefObject<HTMLCanvasElement>;
}

export const ReviewRequestPrintPreview: React.FC<
  ReviewRequestPrintPreviewProps
> = ({ size, qrCodeUrl, options: messages, className = "", qrRef }) => {
  const internalCanvasRef = useRef<HTMLCanvasElement>(null);
  const { t } = useTranslation();
  const canvasRef = qrRef || internalCanvasRef;
  const dimensions = PRINT_DIMENSIONS[size];

  // Generate QR code
  useEffect(() => {
    if (canvasRef.current && qrCodeUrl) {
      QRCode.toCanvas(canvasRef.current, qrCodeUrl, { scale: 8 }, () => {});
    }
  }, [qrCodeUrl, canvasRef]);

  // Get enabled messages
  const enabledMessages = messages.messages
    ? Object.entries(messages.messages)
        .filter(
          ([, langMessage]) =>
            langMessage.enabled && langMessage.message.trim() !== ""
        )
        .map(([, langMessage]) => langMessage.message)
    : [];

  // Calculate aspect ratio for responsive sizing
  const aspectRatio = dimensions.width / dimensions.height;

  return (
    <div
      className={`review-request-print-preview ${size} ${className}`}
      style={{
        aspectRatio: aspectRatio.toString(),
      }}
    >
      <div className="print-content">
        <div className="qr-code-section">
          <canvas ref={canvasRef}></canvas>
        </div>
        <div className="messages-section">
          {enabledMessages.length > 0 ? (
            <div className="messages-list">
              {enabledMessages.map((message, index) => (
                <div key={index} className="message-item">
                  {`• ${message}`}
                </div>
              ))}
            </div>
          ) : (
            <div className="no-messages">
              {t("reviewRequestPrintsPage.noMessagesEnabled")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
